import React, { PureComponent, Children } from 'react'
import { string, node } from 'prop-types'
import { Provider } from '@active/react-utils/i18n/LocaleContext'

import DEFAULT_MESSAGES from '../../../i18n/en_US.json'

export default class LocaleProvider extends PureComponent {
  static propTypes = {
    locale: string,
    children: node.isRequired,
  }

  static defaultProps = {
    locale: 'en_US',
  }

  constructor(props) {
    super(props)
    this.state = {
      // By default, en_us is displayed to prevent error codes from appearing due to slow loading of the locale
      messages: DEFAULT_MESSAGES,
    }
  }

  componentDidMount() {
    const { locale } = this.props
    import(
      /* webpackInclude: /\.json$/ */
      /* webpackExclude: /\.noimport\.json$/ */
      /* webpackChunkName: "locale-[request]-[index]" */
      /* webpackMode: "lazy" */
      `../../../i18n/${locale}.json`).then(messages => {
      this.setState(() => ({
        messages,
      }))
    })
  }

  componentDidUpdate(prevProps) {
    const { locale } = this.props
    if (locale !== prevProps.locale) {
      import(
        /* webpackInclude: /\.json$/ */
        /* webpackExclude: /\.noimport\.json$/ */
        /* webpackChunkName: "locale-[request]-[index]" */
        /* webpackMode: "lazy" */
        `../../../i18n/${locale}.json`).then(messages => this.setState(() => ({
        messages,
      })))
    }
  }

  render() {
    const { children, locale } = this.props
    const { messages } = this.state

    return (
      <Provider locale={locale} locales={messages}>
        {Children.only(children)}
      </Provider>
    )
  }
}
